<template>
  <el-card
    class="settings"
    shadow="never">
    <div
      slot="header"
      class="settings-header">产品组件
      <el-button
        type="danger"
        style="margin-left: 8px;"
        @click="deleteitem">删除</el-button>
    </div>
    <!-- <div>目前只做占位，无配置项，自动获取排序优先级最高的前5个</div> -->
    <goods-top-list />
  </el-card>
</template>
<script>
import GoodsTopList from '../list-top-flag/goods-top-list.vue'
export default {
  name: 'WeGoods',
  components: { GoodsTopList },
  props: {
    value: {
      type: Object,
      default() {
        return { componentName: 'goodsshow', visible: false }
      }
    },
    index: Number
  },
  methods: {
    deleteitem() {
      this.$emit('deleteItem', this.index)
    },
    submit() {
      return Promise.resolve()
    }
  }
}
</script>
<style lang="stylus">
.settings {
  // display: flex;
  // flex-direction: column;
}

.settings .el-card__header {
  padding: 10px 20px;
}

.settings .el-card__body {
  // flex: 1;
  padding: 10px;
  // display: flex;
  // flex-direction: column;
}

.settings .settings-header {
  font-size: 16px;
  font-weight: 600;
}
</style>
